import React, { useEffect, useState } from 'react';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import ArchiveSelectedItem from '../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
import EditPopup from '../../components/Popup/EditPopup/EditPopup'; 
import AddPopup from '../../components/Popup/AddPopup/AddPopup';
import ArchivePopup from '../../components/Popup/ArchivePopup/ArchivePopup';
import EditIcon from '../../components/Table/EditIcon/EditIcon';
import ArchiveIcon from '../../components/Table/ArchiveIcon/ArchiveIcon';
import ExportLabel from '../../components/common/ExportLabel/Export';
import AddButton from '../../components/common/AddButton/AddButton';
import Filter from '../../components/common/Filter/Filter';
import Sort from '../../components/common/Sort/Sort';
import '../../components/common/SubNavbar.css';
import '../../components/common/CommonText.css';
import '../../components/common/Table.css';
import GroupBy from '../../components/common/GroupBy/GroupBy';
import SimpleSearchBox from '../../components/common/Search/SimpleSearch';
import { baseurl } from '../../api';
import { useCheckboxClick } from '../../checkboxclick';
import authenticatedAxios from '../../authenticatedAxios';
import useFilterStore from '../../store/useFilterStore';
import { useNavigate } from 'react-router-dom';
import DeletePopup from '../../components/Popup/DeletePopup/DeletePopup';
import DeleteIcon from '../../components/Table/DeleteIcon/DeleteIcon';
import { isRequired, isTextOnly } from '../../validation';
import useRefreshStore from '../../store/useRefreshStore';
const pageKey = "translations"

const Translations = () => {
  const { setFilters, getFilters } = useFilterStore();
  const savedFilters = getFilters(pageKey);
  const [items, setItems] = useState([]);
  // const [selectedItemsForArchive, setSelectedItems] = useState([]);
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
  const [isNewPopupOpen, setIsNewPopupOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [searchParams, setSearchParams] = useState(savedFilters?.searchParams || { term: "" });
  const [selectedFilterOption, setSelectedFilterOption] = useState(savedFilters?.selectedFilterOption || "Unarchived");
  const [selectedSortOption, setSelectedSortOption] = useState(savedFilters?.selectedSortOption || "Newest"); 
  const [languages, setLanguages] = useState([]);
  const [selectedGroupArchiveAction, setSelectedGroupArchiveAction] = useState('');
  const sortOptions = ['A-Z', 'Z-A', 'Newest', 'Oldest'];
  const filterOptions = ['Default', 'Archived', 'Unarchived'];
  const navigate = useNavigate();
  const groupbyOptions = ['Default','Language'];
  const [groupedItems, setGroupedItems] = useState({});
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedGroupItem, setSelectedGroupItem] = useState(null);
  const [expandedGroups, setExpandedGroups] = useState(new Set());
  const [selectedGroupByOption, setSelectedGroupByOption] = useState('Default');
  const { refreshKeys } = useRefreshStore();
  const refreshKey = refreshKeys["Translations"] || 0;
  const { isParentSelected, selectedItems, handleParentCheckboxChange, handleChildCheckboxChange, resetCheckboxState, } = useCheckboxClick(items);
  const [exportState, setExportState] = useState({
    isExporting: false,
    error: null
  });


  const fetchTranslations = async (id = null) => {
    try {
      setIsLoading(true); // Ensure loading starts at the beginning
  
      let response;
      if (id) {
        // Fetch a specific translation
        response = await authenticatedAxios.get(`${baseurl}localization/translations/?id=${id}`);
        if (response?.data) {
          setSelectedItem(response.data.data);
          setIsEditPopupOpen(true);
        } else {
          console.error("No data found for the selected translation.");
        }
      } else {
        // Fetch all translations
        const params = {
          search: searchParams.term,
          filter: selectedFilterOption === 'Default' ? undefined : selectedFilterOption.toLowerCase(),
          sort: mapSortOptionToQuery(selectedSortOption),
          group_by: selectedGroupByOption.toLowerCase(),
        };
  
        response = await authenticatedAxios.get(`${baseurl}localization/translations/`, { params });
  
        if (response?.data?.response_code === 1) {
          const translations = response.data.data;
          setItems(translations);
  
          // Group items if required
          if (selectedGroupByOption !== 'Default') {
            groupItems(translations, selectedGroupByOption);
          }
        }
      }
    } catch (error) {
      if (error?.response?.data?.error_code === 1001) {
        navigate("/permission-denied"); // Redirect to permission denied page
      } else {
        console.error('Error fetching translations:', error);
      }
    } finally {
      setIsLoading(false); // Always reset loading state
    }
  };
  

  const groupItems = (data, groupBy) => {
    const grouped = data.reduce((acc, item) => {
      let key;
      switch (groupBy.toLowerCase()) {
        case 'language':
          key = item.language.name;
          break;
        default:
          key = 'default';
      }
      
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {});
    
    setGroupedItems(grouped);
  };

  useEffect(() => {
    fetchTranslations();
    setFilters(pageKey, {
      searchParams,
      selectedFilterOption,
      selectedSortOption,
  });
  }, [searchParams, selectedFilterOption, selectedGroupByOption]);

  useEffect(() => {
    fetchTranslations();
  }, [refreshKey]);

  const handleGroupBySelect = (option) => {
    setSelectedGroupByOption(option);
    setSelectedGroup(null);
    setSelectedGroupItem(null);
  };

  const handleGroupItemClick = (groupName) => {
    setSelectedGroup(groupName);
  };

  const getFilteredItems = () => {
    if (selectedGroupByOption === 'Default') {
      return items;
    }
    
    if (selectedGroup) {
      return groupedItems[selectedGroup] || [];
    }
    
    return [];
  };

  const toggleGroup = (groupName) => {
    setExpandedGroups(prev => {
      const newSet = new Set(prev);
      if (newSet.has(groupName)) {
        newSet.delete(groupName);
      } else {
        newSet.add(groupName);
      }
      return newSet;
    });
  };

  const renderGroupedTable = () => {
    if (selectedGroupByOption === 'Default') {
      return (
        <tbody className='common-table-tbody'>
          {renderTableRows(items)}
        </tbody>
      );
    }
    return (
        <tbody className='common-table-tbody'>
          {Object.entries(groupedItems).map(([groupName, groupSubscriptions]) => (
            <React.Fragment key={groupName}>
              <tr className="group-header-row">
                <td colSpan="6" className="group-header">
                  <div 
                    className="group-header-content"
                    onClick={() => toggleGroup(groupName)}
                  >
                    <svg 
                      className={`expand-item-icon ${expandedGroups.has(groupName) ? 'rotated' : ''}`} 
                      width="7" 
                      height="13" 
                      viewBox="0 0 7 13" 
                      fill="none" 
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M7 6.5L0.25 12.9952L0.250001 0.00480908L7 6.5Z" fill="#424242"/>
                    </svg>
                    <span className="group-name common-text fts-15 blue">{groupName}</span>
                    <span className="group-count common-text fts-15 blue">({groupSubscriptions.length})</span>
                  </div>
                </td>
              </tr>
              {expandedGroups.has(groupName) && renderTableRows(groupSubscriptions)}
            </React.Fragment>
          ))}
        </tbody>
      );
    };
    const renderTableRows = (translations) => {
        return translations.length > 0 ? (
          translations.map((translation) => (
            <tr  style={{width:"100%"}} key={translation.id} id='p-relative' className={translation.is_archived ? 'archived-item' : ''}>
                <td  style={{width:"16%"}}>
                  <div className='d-flex ai-center'>
                  <input
                    className="table-selectbox table-child-selectbox"
                    type="checkbox"
                    checked={selectedItems.includes(translation.id)}
                    onChange={() => handleChildCheckboxChange(translation.id)}
                  />{translation.language.name}
                  </div>
                </td>
                <td style={{width:"37%"}}>{translation.content}</td>
                <td style={{width:"37%"}}>{translation.translated_content}</td>
                <td className="actions notification-action " >
                  <EditIcon onClick={() => handleEditClick(translation)} />
                  <ArchiveIcon onClick={() => handleArchiveClick(translation)} isArchived={translation.is_archived}/>
                  <DeleteIcon onClick={() => handleDeleteClick(translation)} />
                </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="6">No states found.</td>
          </tr>
        );
      };


  const fetchLanguages = async () => {
    try {
      const response = await authenticatedAxios.get(`${baseurl}localization/languages/active/`);
      const result = response.data;
      
      if (result.response_code === 1 && Array.isArray(result.data)) {
        setLanguages(result.data.map(language => ({ label: language.name, value: language.id })));
      } else {
        console.error('Fetched languages are not valid:', result);
        setLanguages([]);
      }
    } catch (error) {
      console.error('Error fetching languages:', error);
      setLanguages([]);
    }
  };
  
  useEffect(() => {
    fetchTranslations();
    fetchLanguages();
  }, [searchParams, selectedFilterOption, selectedSortOption]); 

  const handleAddTranslation = async (formValues) => {
    
    try {
        const response = await authenticatedAxios.post(`${baseurl}localization/translations/`, formValues);
        
        
        if (response.status >= 200 && response.status < 300) {
            
            await fetchTranslations();  
            closePopups();
        } else {
            console.error('Failed to add translation');
        }
    } catch (error) {
        console.error('Error adding translation:', error);
    }
  };

  const handleEditTranslation = async (formValues) => {
    try {
      const response = await authenticatedAxios.put(
        `${baseurl}localization/translations/?id=${selectedItem.id}`,formValues);

      if (response.status >= 200 && response.status < 300) {
        await fetchTranslations();
        closePopups();
      } else {
        console.error('Failed to edit translation');
      }
    } catch (error) {
      console.error('Error editing translation:', error);
    }
  };

  const handleDelete = async () => {
    try {
      const response = await authenticatedAxios.delete(
        `${baseurl}localization/translations/?id=${selectedItem.id}`
      );
  
      if (response.status >= 200 && response.status < 300) {
        setIsDeletePopupOpen(false); 
        fetchTranslations(); 
        return;
      }
      throw new Error(`Unexpected status code: ${response.status}`);
    } catch (error) {
      // console.error('Error deleting plan:', error);
    }
  };

  const handleArchiveSelectedItems = async () => {
    try {
        const response = await authenticatedAxios.post(`${baseurl}localization/translations/archive/`, {
        id_list: selectedItems,
      });
  
      if (response.status >= 200 && response.status < 300) {
        fetchTranslations();
        resetCheckboxState();
        closePopups();
      } 
    } catch (error) {
      console.error('Error archiving/unarchiving selected items:', error);
    }
  };
  
  const handleArchive = async () => {
    try {
      const response = await authenticatedAxios.get(
        `${baseurl}localization/translations/archive/?id=${selectedItem.id}`
      );
      
      if (response.status >= 200 && response.status < 300) {
        await fetchTranslations();
        closePopups(); 
      } 
    } catch (error) {
      
    }
  };
  
  const mapSortOptionToQuery = (option) => {
    switch (option) {
      case 'A-Z':
        return 'a_to_z';
      case 'Z-A':
        return 'z_to_a';
      case 'Newest':
        return 'newest';
      case 'Oldest':
        return 'oldest';
      default:
        return 'newest';
    }
  };
  const handleSortOptionSelect = (option) => {
    setSelectedSortOption(option);
    
  };

  const handleFilterSelect = (option) => {
    setSelectedFilterOption(option);
    
  };

  const handleSearchSelect = (searchTerm) => {
    setSearchParams({ term: searchTerm });
  };


  const handleEditClick = (item) => {
    fetchTranslations(item.id)
  };

  const handleDeleteClick = async (item) => {
    setSelectedItem(item);
    setIsDeletePopupOpen(true);
  };

  const handleArchiveClick = async (item) => {
    setSelectedItem(item);
    setIsArchivePopupOpen(true);
  };


  const handleNewClick = () => {
    setSelectedItem(null);
    setIsNewPopupOpen(true);
  };

  const closePopups = () => {
    setIsEditPopupOpen(false);
    setIsArchivePopupOpen(false);
    setIsNewPopupOpen(false);
    setSelectedItem([]);
  };

  const addPopupFields = [
    { label: 'Language', 'name':'language', type: 'large-select',validators: [isRequired, isTextOnly], options:languages, defaultValue: '' },
    { label: 'Content', 'name':'content',type: 'text',validators: [isRequired, isTextOnly], defaultValue: '' },
    { label: 'Translated Content', 'name':'translated_content',type: 'text',validators: [isRequired, isTextOnly], defaultValue: ''}
  ];

  const editPopupFields = [
    { label: 'Language',name:'language', type: 'large-select', options: languages, defaultValue: selectedItem?.language?.id },
    { label: 'CONTENT', type: 'text',name:'content', defaultValue: selectedItem?.content || ''},
    { label: 'Translated CONTENT',name:'translated_content', type: 'text', defaultValue: selectedItem?.translated_content,},
  ];

  const deletePopupFields = [
    { label: 'Are you sure you want to delete this record? Once deleted, it cannot be recovered.', type: 'text' },
  ];

  if (isLoading) {
    return <div>Loading...</div>;
  }
  const handleExportStart = () => {
    setExportState({ isExporting: true, error: null });
  };

  const handleExportComplete = () => {
    setExportState({ isExporting: false, error: null });
    resetCheckboxState();
  };

  const handleExportError = (error) => {
    setExportState({ isExporting: false, error });
  };

  return (
    <div className='whole-container'>
      <div className='top-heading'>
        <PageHeader pageName="Translations" />
        <div className='export-container'>
        <ArchiveSelectedItem
          selectedItems={selectedItems}
          items={items}
          onArchiveSelected={handleArchiveSelectedItems}
        />
          {/* <ExportLabel /> */}
          <ExportLabel
            exportUrl={`${baseurl}localization/translations/export/`}
            selectedIds={selectedItems}
            onExportStart={handleExportStart}
            onExportComplete={handleExportComplete}
            onExportError={handleExportError}
          />

        </div>
      </div>
      <div className='pagename-container'>
        <div className='page-name'>
          <h1 className='common-text fts-22 ftw-6 blue'>Translations</h1>
        </div>
        <div className='pagename-right-container'>
          <AddButton onClick={handleNewClick} />
          <SimpleSearchBox placeholder="Search Translation" onSearchSelect={handleSearchSelect} defaultValue={searchParams?.term}/>
          <GroupBy 
              options={groupbyOptions} 
              selectedOption={selectedGroupByOption}
              onSelect={handleGroupBySelect}
          />
          <Filter options={filterOptions} onFilterSelect={handleFilterSelect} defaultValue={selectedFilterOption}/>
          <Sort options={sortOptions} onOptionSelect={handleSortOptionSelect} defaultValue={selectedSortOption}/>
        </div>
      </div>
      <div className='table-container'>
        <table className='common-table'>
          <thead className='common-table-head'>
            <tr className='common-table-thead-tr'>
              <th className='d-flex ai-center'>
                  <input
                    className="table-selectbox table-parent-selectbox"
                    type="checkbox"
                    checked={isParentSelected}
                    onChange={handleParentCheckboxChange}
                  />LANGUAGE
              </th>
              <th>CONTENT</th>
              <th>TRANSLATED CONTENT</th>
              <th></th>
            </tr>
          </thead>
          {renderGroupedTable()}
        </table>
       
      </div>

      <EditPopup 
        isOpen={isEditPopupOpen}
        title="Translation"
        fields={editPopupFields}
        onSave={handleEditTranslation}
        onClose={closePopups}
      />

      <ArchivePopup
        isOpen={isArchivePopupOpen}
        isArchived={selectedItem?.is_archived }
        archivename={selectedItem?.translated_content }
        onSave={handleArchive}
        onClose={() => setIsArchivePopupOpen(false)}
      />
      <AddPopup 
        isOpen={isNewPopupOpen}
        title="New Translation"
        buttonName='Add Translation'
        fields={addPopupFields}
        onSave={handleAddTranslation}
        onClose={closePopups}
      />
      <DeletePopup
        isOpen={isDeletePopupOpen}
        title="Delete Translation"
        fields={deletePopupFields}
        onSave={handleDelete}
        onClose={closePopups}
      />  
    </div>
  );
};

export default Translations;